<template>
  <div id="app">
    <Header></Header>
    <!-- <ArticleDetails></ArticleDetails> -->
     <KeepAlive>
      <router-view :key="$route.fullPath"></router-view>
     </KeepAlive>
    <Feet></Feet>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Feet from '@/components/Feet'
import ArticleDetails from '@/components/ArticleDetails'

export default {
  name: 'App',
  components: {
    Header,
    ArticleDetails,
    Feet
  }
}
</script>

<style>
html {
  font-size: 12px;
}
body {
  background-color: #f2f2f2;
  font-family: STHeiti, -apple-system, BlinkMacSystemFont, 'PingFang SC',
    'Helvetica Neue', STHeiti, 'Microsoft Yahei', Tahoma, Simsun, sans-serif;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
@media (max-width: 768px) {
  body {
    padding-right: 0 !important;
  }
  .el-message-box{
    width: 80% !important;
  }
}
* {
  margin: 0;
  padding: 0;
  border: 0;
}
::-webkit-scrollbar{
  display:none;
}
a,
a:hover,
a:active,
a:visited,
a:link,
a:focus {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  outline: none;
  background: none;
  text-decoration: none;
  color: #333;
}
/*正常的未被访问过的链接*/
a:link {
  text-decoration: none;
  background-color: transparent;
  outline: none;
}
/*已经访问过的链接*/
a:visited {
  text-decoration: none;
  background-color: transparent;
  outline: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
  text-decoration: none;
}
/* 正在点击的链接，鼠标在元素上按下还没有松开*/
a:active {
  text-decoration: none;
  background-color: transparent;
  outline: none;
}
/* 获得焦点的时候 鼠标松开时显示的颜色*/
a:focus {
  text-decoration: none;
  background-color: transparent;
  outline: none;
}
.el-message-box {
  width: 300px;
}
.el-scrollbar__wrap--hidden-default {
  padding: 20px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
.el-tabs__item {
  user-select: none;
}

.el-tabs__item.is-active {
  color: #f56c6c !important;
}

.el-tabs__item:hover {
  color: #f56c6c !important;
}

.el-tabs__active-bar {
  background-color: #f56c6c !important;
}
.el-button--primary{
  background-color:#f56c6c !important;
  border-color:#f56c6c !important;
}
.el-button--primary:hover{
  background-color:#f56c6c !important;
  border-color:#f56c6c !important;
}
/* body{
  filter: grayscale(100%);
} */
</style>



// WEBPACK FOOTER //
// src/App.vue